import classNames from 'classnames';
import { DetailedHTMLProps, FC, InputHTMLAttributes, useEffect, useRef } from 'react';
import { Button } from '../Button';
import styles from './index.module.scss';

type InputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  onResetInput?: () => void;
};

export const Input: FC<InputProps> = ({ onResetInput, autoFocus, ...props }) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus) {
      ref.current?.focus();
    }
  }, [autoFocus, ref.current]);

  return (
    <div className={styles.inputWrapper}>
      <input
        className={classNames(styles.input, { [styles.inputReset]: onResetInput })}
        {...props}
        ref={ref}
      />
      {onResetInput && (
        <>
          <Button
            onClick={onResetInput}
            type='button'
            aria-label='Reset input search'
            className={styles.inputResetButton}
          >
            <i className='fa-solid fa-xmark'></i>
          </Button>
          <Button
            type='submit'
            aria-label='Submit search form'
            className={styles.inputSubmitButton}
          >
            <i className='fa-solid fa-magnifying-glass'></i>
          </Button>
        </>
      )}
    </div>
  );
};
